export default __webpack_public_path__ + "static/media/7.205ff34c.svg";